import { rankingList } from "@/mocks/home";

const trendIcon = {
  up: { icon: "ri-arrow-up-line", color: "text-primary-600" },
  down: { icon: "ri-arrow-down-line", color: "text-secondary-600" },
  flat: { icon: "ri-subtract-line", color: "text-foreground-400" },
};

export default function Ranking() {
  const maxHeat = rankingList[0].heat;

  return (
    <section id="ranking" className="w-full bg-background-100 px-4 py-16 md:px-6 md:py-24">
      <div className="mx-auto w-full max-w-6xl">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="max-w-xl">
            <span className="font-label text-xs tracking-[0.3em] text-accent-700">HOT LIST</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              今日吃瓜热度榜
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              按讨论量与转发量统计的实时热度排序，榜单每小时滚动一次，热度值越高代表话题越集中。
            </p>
          </div>
          <span className="flex items-center gap-2 self-start rounded-full bg-accent-100 px-4 py-2 text-xs font-medium text-accent-900 md:self-auto">
            <i className="ri-fire-line text-base"></i>
            榜单每 1 小时更新
          </span>
        </div>

        <div className="mt-10 overflow-hidden rounded-lg border border-background-200 bg-background-50 md:mt-14">
          {rankingList.map((item, index) => {
            const trend = trendIcon[item.trend];
            const isTop = item.rank <= 3;
            return (
              <div
                key={item.rank}
                className={`flex flex-col gap-3 px-5 py-5 transition-colors hover:bg-background-100/80 md:flex-row md:items-center md:gap-6 md:px-7 ${
                  index !== 0 ? "border-t border-background-200" : ""
                }`}
              >
                <div className="flex items-center gap-4 md:w-[52%]">
                  <span
                    className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg font-heading text-lg font-bold ${
                      isTop
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    {item.rank}
                  </span>
                  <div className="min-w-0">
                    <h3 className="truncate font-heading text-base font-semibold text-foreground-950 md:text-lg">
                      {item.title}
                    </h3>
                    <div className="mt-1.5 flex items-center gap-2">
                      <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
                        {item.tag}
                      </span>
                      {item.rank === 1 && (
                        <span className="rounded-md bg-primary-100 px-2 py-0.5 text-xs text-primary-800">
                          本日飙升
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="flex flex-1 items-center gap-4">
                  <div className="hidden h-2 flex-1 overflow-hidden rounded-full bg-background-200 md:block">
                    <div
                      className="h-full rounded-full bg-gradient-to-r from-accent-400 to-primary-500"
                      style={{ width: `${Math.round((item.heat / maxHeat) * 100)}%` }}
                    ></div>
                  </div>
                  <span className={`flex items-center gap-1 text-sm ${trend.color}`}>
                    <i className={trend.icon}></i>
                  </span>
                  <span className="w-24 shrink-0 text-right font-heading text-base font-bold text-foreground-900 md:text-lg">
                    {item.heat.toLocaleString()}
                    <span className="ml-1 text-xs font-normal text-foreground-500">热度</span>
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}